module.exports = __webpack_public_path__ + "img/ep-oiseau.5951038a.jpg";